module.exports = __webpack_public_path__ + "static/media/mazon.e68b72b8.gif";